import getters from './getters'
import actions from './actions'
import mutations from './mutations'

const state = () => ({
      loadingPortfolioSymbols: true,
      refreshing: false,
      fetchPortfolioError: false,
      rowPredictionLoading: [],
      items: [],
      colored: [],
      timer: null,
      log: '',
      selectedForEdit: null, // show Edit inputs for row
      selectedItems: [], //choose items for one action (indexes for unsorted items)
      loadingQuotes: false,

      notified_tb_login: false,
      fallbackSymbols: [],
      fallbackTimer: null,

      showBatchPlaceForm: false,
      BatchLimitSource: 1,
      BatchAllocated: 0
});

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
